<template>
  <v-autocomplete
    :class="classPadding"
    :items="items"
    item-value="code"
    item-text="description"
    label="Email Type"
    :loading="loading"
    v-model="item"
    clearable
  ></v-autocomplete>
</template>
<script>
import { isEmpty } from "lodash";
const API_ENDPOINT = "/api/emailType";
export default {
  props: ["value", "classPadding"],
  data: () => ({
    items: [],
    loading: false,
    item: {},
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          if (!isEmpty(data)) {
            this.items = data;
            //this.item = this.items[0];
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getAll();
  },
  watch: {
    value(val) {
      this.item = val;
    },
    item: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },
};
</script>
